import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { Typography } from '@mui/material';

import DailyFinancialMetrics from '../../../DailyFinancialMetrics';

import { fetchDailyTicketByDate } from '../../../../redux/dailyTickets/dailyTicketsThunks';
import { selectSelectedDailyTicket } from '../../../../redux/dailyTickets/dailyTicketsSlice';

const ShiftFinanceDetails = ({ shift, isInDayView = false }) => {
  const selectedDailyTicket = useSelector(selectSelectedDailyTicket);
  const dateString = dayjs(shift.start).format('YYYY-MM-DD');
  const dispatch = useDispatch();

  useEffect(() => {
    // Only fetch daily ticket if we're in the day view
    if (isInDayView && shift.vid) {
      dispatch(fetchDailyTicketByDate({ vid: shift.vid, dateString }));
    }
  }, [dispatch, shift.vid, dateString, isInDayView]);

  if (isInDayView && !selectedDailyTicket) {
    return (
      <Typography variant="h6">No financial data available for this day</Typography>
    );
  }

  return (
    <DailyFinancialMetrics
      shifts={[shift]}
      selectedDailyTicket={selectedDailyTicket}
      isShiftLevel={!isInDayView}
    />
  );
};

export default ShiftFinanceDetails;
